export default __webpack_public_path__ + "static/media/un.52e795d9.svg";